import { render } from "./WebsiteSection.vue?vue&type=template&id=ac799274"
import script from "./WebsiteSection.vue?vue&type=script&lang=js"
export * from "./WebsiteSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__